class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      /* Optimistically set button state from local data to avoid disabled flash */
      if (this.currentVariant.available) {
        this.toggleAddButton(false, '', false);
      } else {
        this.toggleAddButton(true, window.variantStrings.soldOut, false);
      }
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var featured_id = this.currentVariant.featured_media.id;

    /* Use the EXISTING slider instance (set in product_slider) — never
       `new Swiper('.media-nav')`, which spins up a second instance on the
       same element and jams the (vertical, on desktop) gallery. */
    var sw = window.fourMediaSwiper;
    if (!sw || typeof sw.slideTo !== 'function') return;

    var thumbs = document.querySelectorAll('.media-thumb .media-grid-column');
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].dataset.id == featured_id) {
        var idx = parseInt(thumbs[i].dataset.index, 10) - 1; /* data-index is 1-based; slideTo is 0-based */
        if (!isNaN(idx) && idx !== sw.activeIndex) {
          sw.slideTo(idx, 600);
        }
        break;
      }
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      // document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      // document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      // document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      // document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (text === window.variantStrings.soldOut) addButton.classList.add('sold-out');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      addButton.classList.remove('sold-out');
    }
    this.updateAllAtcButtons();
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    addButton.setAttribute('disabled', 'disabled');
    this.updateAllAtcButtons();
  }
  updateAllAtcButtons() {
    /* Keep both desktop (.pdp-atc-btn) and mobile (.pdp-mobile-atc-btn) ATC buttons in sync */
    var allBtns = document.querySelectorAll('.pdp-atc-btn, .pdp-mobile-atc-btn');
    if (!allBtns.length) return;
    var productForm = document.getElementById('product-form-' + this.dataset.section);
    if (!productForm) return;
    var srcBtn = productForm.querySelector('[name="add"]');
    if (!srcBtn) return;
    var isDisabled = srcBtn.hasAttribute('disabled');
    var isSoldOut = srcBtn.classList.contains('sold-out');
    var label = srcBtn.querySelector('span') ? srcBtn.querySelector('span').textContent : '';
    allBtns.forEach(function(btn){
      if (btn === srcBtn) return;
      var span = btn.querySelector('span');
      if (isDisabled) {
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.removeAttribute('disabled');
      }
      if (isSoldOut) {
        btn.classList.add('sold-out');
      } else {
        btn.classList.remove('sold-out');
      }
      if (span && label) span.textContent = label;
    });
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            // console.log("button change")
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
if(document.querySelector('.product-addcart')){
  document.querySelectorAll('.product-addcart').forEach(function(e){
      e.addEventListener('click',function(evt){
      evt.preventDefault();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var cartform = evt.currentTarget.closest('form');
      const formData = new FormData(cartform);  
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(function(e){
            document.querySelector('.product-form-error').innerHTML  = '';
          },2000);
          return;
        }else{
          if(typeof load_cart == 'function'){
            document.body.classList.add("open-drawer");
            load_cart();
          }else{
            window.location.href = "/cart";
          }
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
    
      });
    });
  })
}
  
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var isDesktop = window.innerWidth >= 992;
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: false,
      spaceBetween: 0,
      direction: isDesktop ? 'vertical' : 'horizontal',
      mousewheel: isDesktop ? { forceToAxis: true } : false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      thumbs: {
        swiper: swiper,
      },
    });
    /* Expose the live instances so variant switching (updateMedia) can drive
       the EXISTING slider instead of creating a conflicting new Swiper. */
    window.fourMediaSwiper = swiper2;
    window.fourThumbSwiper = swiper;
  }
}
product_slider();
variant_drodown();
/* If a variant is pre-selected (via ?variant= URL param), enable ATC */
(function(){
  document.querySelectorAll('variant-radios').forEach(function(vr){
    var fieldsets = Array.from(vr.querySelectorAll('.option-wrap'));
    var allChecked = fieldsets.length > 0 && fieldsets.every(function(fs){ return fs.querySelector('input:checked'); });
    if (allChecked) {
      vr.onVariantChange();
    }
  });
})();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}
if(document.querySelector(".add_cart_message .message .close-icon")){
document.querySelector(".add_cart_message .message .close-icon").addEventListener("click",function(){
  this.parentElement.parentElement.classList.remove("active");
})
}
// console.log("geolocation app")
// _ipgeolocation.getGeolocation(uspcountry, "696ed6d4dd4c4559bb0bead9c2db7509");
//   function uspcountry(response) {
//   let continent_name = response.continent_name;
//     if( continent_name == "Europe" ){
//       document.querySelectorAll(".ex_price_sku .discounted_ex_price")[0].style.display="block";
//       document.querySelectorAll(".ex_price_sku .discounted_ex_price")[1].style.display="none";
//     }else{
//       document.querySelectorAll(".ex_price_sku .discounted_ex_price")[0].style.display="none";
//       document.querySelectorAll(".ex_price_sku .discounted_ex_price")[1].style.display="block";
//     }
//   console.log(continent_name,"continent_name")
// }
// uspcountry()